function printondemandSend() {
	/*
	Check for validated elements on the Order Options page in reverse order,
	and set focus on the first field flagged as in error; If no fields in error,
	call PanteraScript.CreatePrintOnDemandOrder web method to create Entries and
	Order
	*/
	var errElem = null;

	if (!validator.element('#ordEmail'))
		errElem = jQuery('#ordEmail');

	if (!validator.element('#ordCountry'))
		errElem = jQuery('#ordCountry');

	if (!validator.element('#ordZip'))
		errElem = jQuery('#ordZip');

	if (!validator.element('#ordCity'))
		errElem = jQuery('#ordCity');

	if (!validator.element('#ordAddress1'))
		errElem = jQuery('#ordAddress1');

	if (!validator.element('#ordPhone'))
		errElem = jQuery('#ordPhone');

	if (!validator.element('#ordContactName'))
		errElem = jQuery('#ordContactName');

	if (!validator.element('#ordCompanyName'))
		errElem = jQuery('#ordCompanyName');

	if (null != errElem) {
		errElem.focus();
		return;
	}

	jQuery('#printondemand-send').prop('disabled', true);

	var ordState = '';
	if (jQuery('#ordCountry').val() == 'CA')
		ordState = jQuery('#ordStateCA').val();
	else
		ordState = jQuery('#ordStateUS').val();

	TogglePrintOnDemandSend();

	fileUploadCounter = 0;

	var largeFormatQuantity = 1;
	var halfSizeQuantity = 0;
	var lfPaper = '';
	var lfBinding = '';
	var smallFormatQuantity = 1;
	var sfPaper = '';
	var sfBinding = '';
	var cdQuantity = 0;
	var deliverBy = '';

	largeFormatQuantity = parseInt(jQuery('#lf-order-sets').val());
	deliverBy = jQuery('#order-deliverby').val();
	lfPaper = jQuery('#lf-paper-type').val();
	lfBinding = jQuery('#lf-binding').val();
	smallFormatQuantity = parseInt(jQuery('#sf-order-sets').val());
	sfPaper = jQuery('#sf-paper-type').val();
	sfBinding = jQuery('#sf-binding').val();
	halfSizeQuantity = parseInt(jQuery('#hs-order-sets').val());
	cdQuantity = parseInt(jQuery('#cd-order-sets').val());

	PanteraScript.PanteraScriptService.CreatePrintOnDemandOrder(pjqSessionId,
		fileUploadGuid,
		jQuery('#ordCompanyName').val(),
		jQuery('#ordContactName').val(),
		jQuery('#ordAddress1').val(),
		jQuery('#ordAddress2').val(),
		jQuery('#ordCity').val(),
		ordState,
		jQuery('#ordZip').val(),
		jQuery('#ordCountry').val(),
		jQuery('#ordPhone').val(),
		jQuery('#ordPhoneExt').val(),
		jQuery('#ordEmail').val(),
		jQuery('#ordProjectRef').val(),
		jQuery('#ordBillingRef').val(),
		jQuery('#order-notes').val(),
		largeFormatQuantity,
		halfSizeQuantity,
		lfPaper,
		lfBinding,
		smallFormatQuantity,
		sfPaper,
		sfBinding,
		cdQuantity,
		deliverBy,
		CreatePrintOnDemandOrderC,
		onScriptError);

}

function TogglePrintOnDemandSend() {
	var disabled = jQuery("#printondemand-send").button("option", "disabled");
	jQuery("#printondemand-send").button("option", "disabled", !disabled);
}

function ordCountryChanged() {
	/*
	Turn fields for State/Province on or off and change Zip Code masking depending on Country field value
	*/
	if (jQuery('#ordCountry').val() == 'CA') {
		jQuery('#ordStateUS').addClass('pjq-hidden');
		jQuery('#ordStateCA').removeClass('pjq-hidden');
		jQuery('#ordStateCA').val('');
		jQuery('#ordZip').val('');
		jQuery('#ordZip').mask("a9a-9a9");
		jQuery('#ordZip').removeClass('zipcodeUS');
		jQuery('#ordZip').addClass('zipcodeCA');
		jQuery('#ordStateCA').focus();
	}
	else {
		jQuery('#ordStateCA').addClass('pjq-hidden');
		jQuery('#ordStateUS').removeClass('pjq-hidden');
		jQuery('#ordStateUS').val('');
		jQuery('#ordStateUS').focus();
		jQuery('#ordZip').val('');
		jQuery('#ordZip').mask("99999");
		jQuery('#ordZip').addClass('zipcodeUS');
		jQuery('#ordZip').removeClass('zipcodeCA');
	}
}

/*
function mediaTypeChanged()
{
   if (jQuery('#rOrderPrint').prop('checked'))
      jQuery('tr.print-option td').css('display','');
   else
      jQuery('tr.print-option td').css('display','none');

}
*/

function PrintOnDemandSettingsC(response) {
	/*
	   Callback for PanteraScriptService.GetPrintOnDemandSettings web method.
	   Sets Recipient info and preferences and calls FileUpload activation function.

	   This object has the following properties:
		  info.FileUploadGuid - the guid to use for this session
		  info.UserId - logged in userid , 0 if logged out -- only if > 0 should you set the following values into the fields.
		  info.CompanyName
		  info.ContactName
		  info.Address1
		  info.Address2
		  info.City
		  info.State
		  info.Zip
		  info.Country
		  info.Phone
		  info.Email
		  info.IsOnAccount - Indicates whether user has on account billing available
		  info.OrderDefLFQty
		  info.OrderDefLFPrintSize
		  info.OrderDefLFPaper
		  info.OrderDefLFBinding
		  info.OrderDefSFQty
		  info.OrderDefSFPaper
		  info.OrderDefSFBinding
		  info.OrderDefDeliverBy
	*/
	jQuery("#ordPhone").mask('(999) 999-9999', {placeholder: " "});
	jQuery('#ordZip').mask("99999");

	var info = jQuery.parseJSON(response);

	fileUploadGuid = info.FileUploadGuid;

	if (info.IsOnAccount) {
		jQuery('#step1hdr').html('Upload Files - Step 1 of 2');
		jQuery('#step2hdr').html('Order Info - Step 2 of 2');
	}
	else {
		jQuery('#step1hdr').html('Upload Files - Step 1 of 3');
		jQuery('#step2hdr').html('Order Info - Step 2 of 3');
	}

	if (info.UserId > 0) {
		jQuery('#ordCompanyName').val(info.CompanyName);
		jQuery('#ordContactName').val(info.ContactName);
		jQuery('#ordPhone').val(info.Phone);
		jQuery('#ordAddress1').val(info.Address1);
		jQuery('#ordAddress2').val(info.Address2);
		jQuery('#ordCity').val(info.City);
		jQuery('#ordZip').val(info.Zip);
		jQuery('#ordCountry').val(info.Country);
		jQuery('#ordEmail').val(info.Email);
		if (info.Country == "CA") {
			jQuery('#ordStateCA').val(info.State);
			jQuery('#ordStateUS').addClass('pjq-hidden');
			jQuery('#ordStateCA').removeClass('pjq-hidden');
			jQuery('#ordZip').mask("a9a-9a9");
			jQuery('#ordZip').removeClass('zipcodeUS');
			jQuery('#ordZip').addClass('zipcodeCA');
		}
		else {
			jQuery('#ordStateUS').val(info.State);
			jQuery('#ordStateCA').addClass('pjq-hidden');
			jQuery('#ordStateUS').removeClass('pjq-hidden');
			jQuery('#ordZip').mask("99999");
			jQuery('#ordZip').addClass('zipcodeUS');
			jQuery('#ordZip').removeClass('zipcodeCA');
		}

	}
	else {
		jQuery('#ordCountry').val("US");
	}

	jQuery('#lf-order-sets').spinner({min: 0, max: 25});
	jQuery('#hs-order-sets').spinner({min: 0, max: 25});
	jQuery('#sf-order-sets').spinner({min: 0, max: 25});
	jQuery('#cd-order-sets').spinner({min: 0, max: 25});
	jQuery('#hs-order-sets').val(0);
	jQuery('#cd-order-sets').val(0);
	jQuery('#lf-order-sets').val(info.OrderDefLFQty);
	jQuery('#lf-paper-type').val(_.size(info.OrderDefLFPaper) > 0 ? info.OrderDefLFPaper : 'WHITE BOND');
	jQuery('#lf-binding').val(_.size(info.OrderDefLFBinding) > 0 ? info.OrderDefLFBinding : 'STAPLED');
	jQuery('#sf-order-sets').val(info.OrderDefSFQty);
	jQuery('#sf-paper-type').val(_.size(info.OrderDefSFPaper) > 0 ? info.OrderDefSFPaper : 'WHITE BOND');
	jQuery('#sf-binding').val(_.size(info.OrderDefSFBinding) > 0 ? info.OrderDefSFBinding : 'STAPLED');
	jQuery('#order-deliverby').val(_.size(info.OrderDefDeliverBy) > 0 ? info.OrderDefDeliverBy : 'Two Day');

	ActivateUpload();
	// quick debug check to make sure the function is returning appropriate values, can try this both logged in as lakeviewdc, and not logged in.
	// alert(info.UserId.toString());

}

function CreatePrintOnDemandOrderC(response) {
	/*
	   Callback for PanteraScriptService.CreatePrintOnDemandOrder web method.
	   Displays messages or redirects to Payment page depending on return values
	*/
	var info = jQuery.parseJSON(response);

	if (!info.OrderComplete) {
		showInfoDialog('System Error', 'An error occurred while saving Order Data.  Please contact the System Administrator.');
	}
	else if (info.IsPaymentInfo) {
		new PJQ.views.BaseModal({
			header: "Order Completed",
			body: 'Your order has been submitted. The Order ID is ' + info.OrderID,
			isShowCancelButton: false,
			onOk: _.bind(function () {
				if (subOrderContext === 0)
					window.location.reload(true);
				else
					window.location.href = '/Default.aspx?tabId=' + subOrderContext;
			}, this)
		});

	}
	else {
		var url = 'http://';
		if (window.location.hostname.startsWith('www.panteratools') || window.location.hostname.startsWith('planexpress') || window.location.hostname.startsWith('printblueprints'))
			url = 'https://';

		var orderType = 'OrderDisc';
		if (jQuery('#rOrderPrint').prop('checked'))
			orderType = 'OrderPrints';

		var subOrder = '';
		if (subOrderContext > 0)
			subOrder = '&suborder=' + subOrderContext;

		url = url + window.location.hostname + '/DesktopModules/PanteraModuleGlobal/OrderPayment.aspx?oc=SEND_AND_PRINT&o=' + info.OrderID + '&ot=' + orderType + subOrder;
		window.location.href = url;
	}
}

function ClearRecipientInfo() {
	jQuery("#recipient-info input").val('');
}

function BackToDocuments() {
// Hides the Order Options page and redisplays the Documents page
	jQuery('#pod-documents').removeClass('pjq-hidden');
	jQuery("#pod-options").addClass('pjq-hidden');
}